/**
 * Partners Block Animation Script
 * Добавляет анимацию для списка партнеров на мобильных устройствах
 */

(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    // Проверяем ширину экрана
    function shouldAnimate() {
      return window.innerWidth <= 989;
    }

    // Инициализация анимации
    function initAnimation() {
      const partnersList = document.querySelector('.partners-list');
      
      if (!partnersList || !shouldAnimate()) {
        return;
      }

      // Создаем Intersection Observer
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
            // Отключаем observer после анимации
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.2, // Запускаем анимацию когда 20% элемента видно
        rootMargin: '0px'
      });

      observer.observe(partnersList);
    }

    // Инициализация при загрузке
    initAnimation();

    // Переинициализация при изменении размера окна
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        const partnersList = document.querySelector('.partners-list');
        if (partnersList) {
          if (shouldAnimate()) {
            // Если размер экрана подходит и анимация еще не была запущена
            if (!partnersList.classList.contains('animate-in')) {
              initAnimation();
            }
          } else {
            // Убираем стили анимации если экран больше 989px
            partnersList.classList.remove('animate-in');
          }
        }
      }, 250);
    });
  });
})();
